import Constants from './constants'
const initialState = {
  list: [],
  item: {},
  users: [],
  page: 1,
  per_page: 50,
  total_record: 0,
  activityTypes: [],
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
}

const reducer = function ordersReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.LOAD_ACTIVITIES:
      return {
        ...state,
        list: [],
        item: {},
        total_record: 0,
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
      }
    case Constants.LOAD_ACTIVITIES_XLS:
      return {
        ...state,
        data: action.payload,
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
      }
    case Constants.SET_ACTIVITIES:
      return {
        ...state,
        list: action.payload.records,
        total_record: action.payload.total_record,
        requesting: false,
        successful: true,
        errors: [],
      }
    case Constants.LOAD_USERS:
      return {
        ...state,
        users: [],
        requesting: true,
        successful: false,
        errors: [],
      }
    case Constants.UPDATE_ACTIVITYTYPES:
      return {
        ...state,
        requesting: true,
      }
    case Constants.SET_USERS:
      return {
        ...state,
        users: action.payload,
        requesting: false,
        successful: true,
        errors: [],
      }
    case Constants.LOAD_ACTIVITYTYPES:
      return {
        ...state,
        activityTypes: [],
        requesting: true,
        successful: false,
        errors: [],
      }
    case Constants.SET_ACTIVITYTYPES:
      return {
        ...state,
        activityTypes: action.payload,
        requesting: false,
        successful: true,
        errors: [],
      }
    case Constants.SET_MESSAGE:
      return {
        ...state,
        messages: [{
          body: action.payload,
          time: new Date().getTime(),
        }]
      }
    case Constants.SET_ERROR:
      return {
        ...state,
        errors: [{
          body: action.payload,
          time: new Date().getTime(),
        }]
      }
    case Constants.SET_LOADING:
      return {
        ...state,
        requesting: action.payload
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Admin/ActivityLog/reducer.js